import type { ReactElement } from 'react';

import { AppRouterProvider } from './providers/app-router.provider';
import { QueryProvider } from './providers/query.provider';
import { ThemeProvider } from './providers/theme/theme.provider';
import { AppErrorBoundary } from './shared/errors/app-error-boundary.component';

function App(): ReactElement {
  return (
    <AppErrorBoundary>
      <ThemeProvider>
        <QueryProvider>
          <AppRouterProvider />
        </QueryProvider>
      </ThemeProvider>
    </AppErrorBoundary>
  );
}

export default App;
